<div class="container-fluid viewBox gap-3">
    <div >
        <button (click)="closeDialog()" class="closeHeader">
            <img src="./assets/images/close cross.svg"  alt="Unable to load image">
        </button>
    </div>
    <div class="d-flex" *ngIf="isSuccess">
            <img class="check" src="./assets/images/check.svg"  alt="Unable to load image">
            <p class="successMsg">{{successMsg}}</p>
    </div>
    <div class="row title">
        Coverage Details
    </div>
    <div id="printSection" class="container">
    <div id="CoverageDetails">
    <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <div><img class="logo" src="./assets/images/MD_Logo.png"  alt="Unable to load image" /></div>
            <div><img class="ifcImage" src="./assets/images/ifs.png"  alt="Unable to load image"/></div>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 d-grid gap-3">
            <div class="row mt-2">
                <div class="col-lg-3 col-md-4 col-sm-4">
                  <div class="label">Roster Number</div>
                  <div class="value">{{ rosterCoverage.rosterNo }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                  <div class="label">Campus Name</div>
                  <div class="value">{{ rosterCoverage.campusName }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                  <div class="label">Activity</div>
                  <div class="value">{{ rosterCoverage.activity }}</div>
              </div>
            </div>
            <div class="row field">
                <div class="col-lg-3 col-md-4 col-sm-4">
                    <div class="label">Demographics</div>
                    <div class="value">{{ rosterCoverage.demographics }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="label">Marketing Plan</div>
                    <div class="value">{{ rosterCoverage.marketingPlan }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4"></div>
            </div>
            <div class="row field">
                <div class="col-lg-3 col-md-4 col-sm-4">
                    <div class="label">Plan Rate</div>
                    <div class="value">{{ rosterCoverage.planRate }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="label">Student Rate</div>
                    <div class="value">{{ rosterCoverage.studentRate }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                  <div class="label">Student Count</div>
                  <div class="value">{{ coveredStudents.length }}</div>
                </div>
            </div>
            <div class="row field">
                <div class="col-lg-3 col-md-4 col-sm-4">
                    <div class="label">Check No</div>
                    <div class="value">{{ rosterCoverage.checkNo }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="label">Check Amount</div>
                    <div class="value">{{ rosterCoverage.checkAmt|number:'1.2-2' }}</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="label">Check Date</div>
                    <div class="value">{{ rosterCoverage.checkDate | date:'yyyy-MM-dd' }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-2" style="margin-bottom: -25px">
      <div class="alert alert-info pt-3 pb-0 rounded-1">
        <div class="mx-2 mb-2">
          <p>Checks can be mailed to: </p>
        </div>
        <div class="mx-2">
          <p>
            Insurance for Students, Inc.<br>
            Attn: Kyle Slaydon<br>
            95 Elm Street, Ste 200<br>
            West Springfield, MA 01089
          </p>
        </div>
      </div>
    </div>

  </div>
</div>
    <div class="row title">
        Student Details
    </div>
    <div class="row ">
        <div class="studentTable">
            <div class="col-lg-12 col-md-12 col-sm-12 horizontalTableScroll">
                <table id="studenrDetailsTable" aria-label="Coverage Details" mat-table [dataSource]="dataSource" *ngIf="dataSource.filteredData.length>0">
                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell *matHeaderCellDef> First Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="middleName">
                        <th mat-header-cell *matHeaderCellDef> Middle Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.middleName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef> Last Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="studentID">
                        <th mat-header-cell *matHeaderCellDef> Student ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.ssn}} </td>
                    </ng-container>
                    <ng-container matColumnDef="dateOfBirth">
                        <th mat-header-cell *matHeaderCellDef> Date of Birth </th>
                        <td mat-cell *matCellDef="let element"> {{element.dob | date:'yyyy-MM-dd'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="paidPremiumDate">
                        <th mat-header-cell *matHeaderCellDef> Date Student<br>Paid Premium </th>
                        <td mat-cell *matCellDef="let element"> {{element.paidDate | date:'yyyy-MM-dd'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="paymentMethod">
                        <th mat-header-cell *matHeaderCellDef> Student Payment Method<br>(Cash, Check/M.O)</th>
                        <td mat-cell *matCellDef="let element"> {{element.paymentMethod}} </td>
                    </ng-container>
                    <ng-container matColumnDef="checkNumber">
                        <th mat-header-cell *matHeaderCellDef> Check Number </th>
                        <td mat-cell *matCellDef="let element"> {{element.checkNo}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="dispColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: dispColumns;"></tr>
                </table>

                <!--Paginator-->
                <!-- <div class="row d-flex paginator" *ngIf="dataSource.filteredData.length>0">
                    <div class="col-lg-1 col-md-1 col-sm-2">
                        <button class="pagControls" mat-button (click)="paginator.previousPage()">
                            <img src="./assets/images/left-arrow.svg"  alt="Unable to load image">
                            Prev
                        </button>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-8 pageNumbers">
                        <ng-container *ngFor="let no of pageNumbers; let i = index;">
                            <button mat-button (click)="UpdateManualPage(no-1)"
                                [ngClass]="{'activePage':dataSource.paginator!.pageIndex==no-1}">{{no}}</button>
                            <ng-container *ngIf="i == 1 && noOfPages > 4">
                                ...
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-2">
                        <button class="pagControls" mat-button (click)="paginator.nextPage()">
                            Next
                            <img src="./assets/images/right-arrow.svg"  alt="Unable to load image">
                        </button>
                    </div>
                </div>

                <mat-paginator style="visibility: hidden;" [pageIndex]="pageIndex" #paginator
                    [length]="coveredStudents.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]"
                    (page)="pageEvent = $event"></mat-paginator> -->
                    <!-- <div class="row d-flex paginator">
                        <div class="col-lg-6 col-sm-6 col-md-6">
                          <div class="row">
                              <div class="col-lg-4 col-md-4 col-sm-4">
                                <mat-form-field class="go-to-select">
                                  <mat-label >Go To Page:</mat-label>
                                  <mat-select  [(ngModel)]="goTo" (selectionChange)="goToChange()">
                                      <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
                                  </mat-select>
                              </mat-form-field>
                             </div>
                             <div class="col-lg-4 col-md-4 col-sm-4">

                          </div>
                              <div class="col-lg-4 col-md-4 col-sm-4">
                                <span> Page {{selectedPageNumber}} of {{currenttotalPages}}</span>
                              </div>
                          </div>



                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <mat-paginator
                        #paginator
                        [pageSize]="999"
                        [length]="coveredStudents.length"
                        (page)="onPaginateChange($event)"
                      ></mat-paginator>
                      </div>

                      </div> -->
                <div *ngIf="dataSource.filteredData.length==0" class="noroster">No Records found</div>
                <div *ngIf="isSuccess" class="buttons">
                    <button class="backToRoster" (click)="BackToRoster()">Back to Roster</button>
                    <button class="newRoster" (click)="RouteToAddRoster()">Add New Roster</button>
                </div>

            </div>
            <div  class=" row buttons mb-4 mt-3" >
                <button *ngIf="!isSuccess" class="backToRoster" (click)="BackToRoster()">Back to Roster</button>
                <button *ngIf="!isSuccess" class="btn btn-danger" (click)="printAsPDF()">Export to PDF</button>
                <button *ngIf="!isSuccess" class="btn btn-success" (click)="printAsExcel()">Export to Excel</button>


            </div>
        </div>
    </div>
</div>
